module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "copya"
  }, [_vm._v("Publisher: Amy Barrett-Daffin")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Creative Director: Gailen Runge")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Senior Editor: Roxane Cerda")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Editor: Madison Moore")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Technical Editor: Debbie Rodgers")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Cover/Book Designer: April Mostek")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Production Coordinator: Tim Manibusan")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Illustrator: Linda Johnson")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Photography Coordinator: Lauren Herberg")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Photography Assistant: Rachel Ackley")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Photography by Lauren Herberg, Gailen Runge of C&T Publishing, Inc., unless otherwise noted")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Published by C&T Publishing, Inc., P.O. Box 1456, Lafayette, CA 94549")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg2_1.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-441e97cd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_copyright.vue
// module id = 60
// module chunks = 0